import AutoPayStatus from './components/AutoPayStatus'
import DetailCard from './components/DetailCard'
import EmiDetail from './components/EmiDetail'
import ForeclosureCard from './components/ForeclosureCard'
import RowListCard from './components/RowListCard'

export default function getLoanDetailComponent(component, index) {
  switch (component?.type) {
    case 'detail_card':
      return <DetailCard data={component} key={`${component?.type}-${index}`} />
    case 'emi_detail':
      return <EmiDetail data={component} key={`${component?.type}-${index}`} />
    case 'auto_pay_status':
      return <AutoPayStatus data={component} key={`${component?.type}-${index}`} />
    case 'forclosure_card':
      return <ForeclosureCard data={component} key={`${component?.type}-${index}`} />
    case 'row_list_card':
      return <RowListCard data={component} key={`${component?.type}-${index}`} />
    default:
      return null
  }
}
